import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { formatMoney } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import ToastModal from "views/components/ToastModal";
import { goldRateData } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { parseDate } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";
import { formatDateTime } from "utils/Utils";

const GoldRates = ({featureFlagState}) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const enabledRefreshGoldRatesButton = parseAndSetFlag(featureFlagState?.enabledRefreshGoldRatesButton);
  const { authToken } = useSelector((state) => state.login.authData);
  const [lastUpdated, setLastUpdated] = useState("");
  const handlegoldrateSubmit = async () => {
    navigate(goldRateData?.createUrl);
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_GOLDRATE_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
        toastUpdate(toastAction?.error, result?.data?.user_description,true);
    } else {
      result?.data?.sort((a, b) => b?.purity.localeCompare(a?.purity));
      parseIndicatorData(result?.data);
    }
  };
    const parseIndicatorData = (data) => {
      let reportData = [];
      const updatedDate = formatDateTime(data?.[0]?.updatedOn);
      
      data?.forEach((goldpay) => {
        let row = {
          fitnesscode: goldpay?.purity,
          leadingrate:
            goldpay?.currencyCode + " " + formatMoney(goldpay?.lendingPrice),
        
          marketrate:
          goldpay?.purity === "22k" ? (
            <span>
              {goldpay?.currencyCode} {formatMoney(goldpay?.marketPrice)}
              {enabledRefreshGoldRatesButton &&
              <span
                style={{
                  color: "green",
                  marginLeft: "10px",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                (Updated: {updatedDate})
              </span>}
            </span>
          ) : (
            ""
          ),
        };
      
        reportData.push(row);
      });
    
      setSelectedTableData(reportData);
    };
  const handleRefreshRates = async() => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_GOLDRATE_REFERSH,
      authToken: authToken,
      data: {
        data: parseDate(new Date())
      },
      method: "POST"
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate(toastAction?.error, result?.data?.user_description,true);
    }else{
      toastUpdate(toastAction?.success, "Rates refreshed successfully",true);
      GetData();
    }
  }
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <SubHeader
            label={goldRateData?.label}
            button1={goldRateData?.button}
            button1click={handlegoldrateSubmit}
            refreshButton={enabledRefreshGoldRatesButton ? true : false}
            refreshButtonClick={handleRefreshRates}
            refreshDisabled={callInProgress}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ColumnGroupingTable
            columns={goldRateData?.tableColumns}
            rows={selectedTableData}
          />
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
      </GridContainer>
    </div>
  );
};

GoldRates.propTypes = {
  featureFlagState: PropTypes.object,
};

export default GoldRates;
